import { createSlice } from "@reduxjs/toolkit"
import {
  addRegion,
  deleteRegion,
  getAllRegionList,
  getAllRegions,
  getRegionDetails,
  updateRegion,
  updateRegionStatus,
} from "store/actions/regionAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 10,
  totalPages: null,
  currentPage: 1,
  regions: [],
  regionList: [],
  regionDetails: {},
}

const usersSlice = createSlice({
  name: "region",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET ALL REGIONS
    builder
      .addCase(getAllRegions.pending, state => {
        state.loading = true
      })
      .addCase(getAllRegions.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.regions = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllRegions.rejected, (state, action) => {
        state.loading = false
      })

    // GET ALL REGIoNS LISTS
    builder
      .addCase(getAllRegionList.pending, state => {})
      .addCase(getAllRegionList.fulfilled, (state, action) => {
        const { status, data } = action.payload
        if (status) {
          state.regionList = data
        }
      })
      .addCase(getAllRegionList.rejected, (state, action) => {})

    // UPDATE REGION STATUS
    builder
      .addCase(updateRegionStatus.pending, state => {
        state.isLoading = true
      })
      .addCase(updateRegionStatus.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          state.regions = state.regions.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
        }
      })
      .addCase(updateRegionStatus.rejected, (state, action) => {
        state.isLoading = false
      })

    // ADD COUNTRY
    builder
      .addCase(addRegion.pending, state => {
        state.isLoading = true
      })
      .addCase(addRegion.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addRegion.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET REGION DETAILS
    builder
      .addCase(getRegionDetails.pending, state => {
        state.loading = true
        state.regionDetails = {}
      })
      .addCase(getRegionDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.regionDetails = data
        }
      })
      .addCase(getRegionDetails.rejected, (state, action) => {
        state.loading = false
      })

    //  UPDATE REGION
    builder
      .addCase(updateRegion.pending, state => {
        state.isLoading = true
        state.countryDetails = {}
      })
      .addCase(updateRegion.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateRegion.rejected, (state, action) => {
        state.isLoading = false
      })

    // DELETE REGION
    builder
      .addCase(deleteRegion.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteRegion.fulfilled, (state, action) => {
        const { status } = action.payload
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.regions = state.regions.filter(item => item._id !== id)
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteRegion.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
